import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { API_GET_PDF_TITRE_DETENTION } from 'constants/apiUrls.constants';
import { GroupeBouton } from '@design-system-etat/dsfr-react';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import { MIME_APPLICATION_OCTET_STREAM, MIME_APPLICATION_PDF } from 'constants/fileConstant';
import axios from 'axios';

const TitreDetentionTelechargementBouton = ({ titreDetention }) => {
    const [Base64TelechargementTitreDetention, setBase64TelechargementTitreDetention] = useState({
        data: null,
        isLoading: false,
    });

    // TODO: creer un util pour les appels API axios
    const genererPdfAutorisationDetentionArme = (titreDeDetention) => {
        setBase64TelechargementTitreDetention({
            ...Base64TelechargementTitreDetention,
            isLoading: true,
        });
        axios
            .get(
                process.env.REACT_APP_API_DETENTEURS_URL +
                    API_GET_PDF_TITRE_DETENTION.replace(
                        ':type',
                        'autorisation-detention-arme',
                    ).replace(':uuid', titreDeDetention.uuid),
            )
            .then((payload) =>
                setBase64TelechargementTitreDetention({
                    data: payload.data.data,
                    isLoading: false,
                }),
            )
            .catch(() =>
                setBase64TelechargementTitreDetention({
                    ...Base64TelechargementTitreDetention,
                    isLoading: false,
                }),
            );
    };

    return (
        <GroupeBouton isHorizontal>
            {/* REMARQUE: laissé au cas où la visualisation serait demandé (US 4452)
                <Link className="fr-nav" to="https://www.google.com/">
                    <Bouton label="Visualiser" icone="fr-fi-eye-line" niveau="secondaire" />
                </Link> */}
            <BoutonFichierTelechargeable
                handleOnClick={() => genererPdfAutorisationDetentionArme(titreDetention)}
                label="label"
                isLoading={Base64TelechargementTitreDetention.isLoading}
                titreFichier={`decision-autorisation-acquisition-detention-armes-${titreDetention.numero}.pdf`}
                mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                contenu={Base64TelechargementTitreDetention.data}
                iconOnly
                key={`telechargement-${titreDetention.uuid}`}
            />
        </GroupeBouton>
    );
};

TitreDetentionTelechargementBouton.propTypes = {
    titreDetention: PropTypes.object,
};

export default TitreDetentionTelechargementBouton;
